import {ServiceRegistry} from './service-registry';

export abstract class Service {
    protected services: ServiceRegistry;

    constructor(services: ServiceRegistry) {
        this.services = services;
    }
}
